import React from 'react'
import PropTypes from 'prop-types'

const Label = (
  ({
    color,
    children,
    style,
  }) => (
    <p
      style={{
        fontSize: 16,
        color,
        marginBottom: 0,
        ...style,
      }}
    >
      {children}
    </p>
  )
)

Label.propTypes = {
  color: PropTypes.any,
  children: PropTypes.node,
  style: PropTypes.any,
}
Label.defaultProps = {
  color: undefined,
  children: undefined,
  style: undefined,
}

export default Label



// WEBPACK FOOTER //
// ./src/components/labels/Label.js